define('RunOnEveryPage/components/pdfViewerTarget',[
],
    function () {
        function init() {
            $(document).ready(function ($) {
                setPdfViewerTargetToBlank();
            });

            $(document).on("ajaxComplete", function () {
                setPdfViewerTargetToBlank();
            });
        }

        function setPdfViewerTargetToBlank() {
            $('a[href^="/pdfviewer?"]').each(function () {
                if (!$(this).attr("target"))
                    $(this).attr("target", "_blank");
            });
        }
                
        return {
            init: init
        };
    }
);

